module.exports = __webpack_public_path__ + "static/img/xuebi_24.9d2c011d.png";